import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from 'src/app/services/security-service/security.service';
import { Device } from '../../models/device-models/device.model';

@Injectable()
export class UserStorageService {

  private MBASE_UDID_ID = 'mb_ui';
  private MBASE_LANG_ID = 'mb_la';
  private MBASE_CONTEXT_ID = 'mb_cx';
  private MBASE_DEVICEDATA_ID = 'mb_cd';
  private MBASE_BO_VERSION = 'mb_vv';
  private MBASE_OAUTH_TOKEN = 'mb_oa';
  private MBASE_COMPANY_ID = 'mb_ci';
  private MBASE_SELECTED_DESK = 'mb_desk';
  private MBASE_SELECTED_LOCATION_DESK = 'mb_location_desk';
  private MBASE_SOUND_STATE = 'mb_ss';

  constructor(private router: Router,
              private securityService: SecurityService) { }

  public setContext(context) {
    if (context) {
      try {
        localStorage.setItem(this.MBASE_CONTEXT_ID, this.securityService.encrypt(context));
        return true;
      } catch (e) {
        console.log('Fail saving context token in browser. ' + e);
        return false;
      }
    } else {
      return false;
    }
  }

  public getContext() {
    if (localStorage.getItem(this.MBASE_CONTEXT_ID)) {
      try {
        const context = this.securityService.decrypt(localStorage.getItem(this.MBASE_CONTEXT_ID));
        return context;
      } catch (e) {
        console.log('Fail retrieving context token from browser. ' + e);
        return null;
      }
    } else {
      return null;
    }
  }

  public setLang(lang) {
    if (lang) {
      try {
        localStorage.setItem(this.MBASE_LANG_ID, this.securityService.encrypt(lang));
        return true;
      } catch (e) {
        console.log('Fail saving lang token in browser. ' + e);
        return false;
      }
    } else {
      return false;
    }
  }

  public getLang() {
    if (localStorage.getItem(this.MBASE_LANG_ID)) {
      try {
        const context = this.securityService.decrypt(localStorage.getItem(this.MBASE_LANG_ID));
        return context;
      } catch (e) {
        console.log('Fail retrieving lang token from browser. ' + e);
        return null;
      }
    } else {
      return null;
    }
  }

  public setUDID(udid) {
    if (udid) {
      try {
        localStorage.setItem(this.MBASE_UDID_ID, this.securityService.encrypt(udid));
        return true;
      } catch (e) {
        console.log('Fail saving udid token in browser. ' + e);
        return false;
      }
    } else {
      return false;
    }
  }

  public getUDID() {
    if (localStorage.getItem(this.MBASE_UDID_ID)) {
      try {
        const udid = this.securityService.decrypt(localStorage.getItem(this.MBASE_UDID_ID));
        return udid;
      } catch (e) {
        console.log('Fail retrieving udid token from browser. ' + e);
        return null;
      }
    } else {
      return null;
    }
  }

  public setDeviceData(deviceData) {
    if (deviceData) {
      try {
        localStorage.setItem(this.MBASE_DEVICEDATA_ID, this.securityService.encrypt(JSON.stringify(deviceData)));
        return true;
      } catch (e) {
        console.log('Fail saving device data in browser. ' + e);
        return false;
      }
    } else {
      return false;
    }
  }

  public getDeviceData() {
    if (localStorage.getItem(this.MBASE_DEVICEDATA_ID)) {
      try {
        const deviceData = new Device();
        Object.assign(deviceData, JSON.parse(this.securityService.decrypt(localStorage.getItem(this.MBASE_DEVICEDATA_ID))));
        return deviceData;
      } catch (e) {
        console.log('Fail retrieving device data from browser. ' + e);
        return null;
      }
    } else {
      return null;
    }
  }

  public setBOVersion(boVersion) {
    if (boVersion) {
      try {
        localStorage.setItem(this.MBASE_BO_VERSION, this.securityService.encrypt(JSON.stringify(boVersion)));
        return true;
      } catch (e) {
        console.log('Fail saving BO version in browser. ' + e);
        return false;
      }
    } else {
      return false;
    }
  }

  public getBOVersion() {
    if (localStorage.getItem(this.MBASE_BO_VERSION)) {
      try {
        return JSON.parse(this.securityService.decrypt(localStorage.getItem(this.MBASE_BO_VERSION)));
      } catch (e) {
        console.log('Fail retrieving BO version from browser. ' + e);
        return null;
      }
    } else {
      return null;
    }
  }

  public setOAuthToken(oAuthToken) {
    if (oAuthToken) {
      try {
        localStorage.setItem(this.MBASE_OAUTH_TOKEN, this.securityService.encrypt(JSON.stringify(oAuthToken)));
        return true;
      } catch (e) {
        console.log('Fail saving oauth token in browser. ' + e);
        return false;
      }
    } else {
      return false;
    }
  }

  public getOAuthToken() {
    if (localStorage.getItem(this.MBASE_OAUTH_TOKEN)) {
      try {
        return JSON.parse(this.securityService.decrypt(localStorage.getItem(this.MBASE_OAUTH_TOKEN)));
      } catch (e) {
        console.log('Fail retrieving oauth token from browser. ' + e);
        return null;
      }
    } else {
      return null;
    }
  }

  public setCompanyInternalId(internalId) {
    if (internalId) {
      try {
        localStorage.setItem(this.MBASE_COMPANY_ID, this.securityService.encrypt(JSON.stringify(internalId)));
        return true;
      } catch (e) {
        console.log('Fail saving company internal id in browser. ' + e);
        return false;
      }
    } else {
      return false;
    }
  }

  public getCompanyInternalId() {
    if (localStorage.getItem(this.MBASE_COMPANY_ID)) {
      try {
        return JSON.parse(this.securityService.decrypt(localStorage.getItem(this.MBASE_COMPANY_ID)));
      } catch (e) {
        console.log('Fail retrieving company internal id from browser. ' + e);
        return null;
      }
    } else {
      return null;
    }
  }

  public setSelectedDesk(desk) {
    if (desk) {
      try {
        localStorage.setItem(this.MBASE_SELECTED_DESK, this.securityService.encrypt(JSON.stringify(desk)));
        return true;
      } catch (e) {
        console.log('Fail saving selected desk in browser. ' + e);
        return false;
      }
    } else {
      localStorage.removeItem(this.MBASE_SELECTED_DESK);
      return false;
    }
  }

  public setSelectedLocationDesk(location) {
    if (location) {
      try {
        localStorage.setItem(this.MBASE_SELECTED_LOCATION_DESK, this.securityService.encrypt(JSON.stringify(location)));
        return true;
      } catch (e) {
        console.log('Fail saving selected location desk in browser. ' + e);
        return false;
      }
    } else {
      localStorage.removeItem(this.MBASE_SELECTED_LOCATION_DESK);
      return false;
    }
  }

  public getSelectedDesk() {
    if (localStorage.getItem(this.MBASE_SELECTED_DESK)) {
      try {
        return JSON.parse(this.securityService.decrypt(localStorage.getItem(this.MBASE_SELECTED_DESK)));
      } catch (e) {
        console.log('Fail retrieving selected desk from browser. ' + e);
        return null;
      }
    } else {
      return null;
    }
  }

  public getSelectedLocationDesk() {
    if (localStorage.getItem(this.MBASE_SELECTED_LOCATION_DESK)) {
      try {
        return JSON.parse(this.securityService.decrypt(localStorage.getItem(this.MBASE_SELECTED_LOCATION_DESK)));
      } catch (e) {
        console.log('Fail retrieving selected location desk from browser. ' + e);
        return null;
      }
    } else {
      return null;
    }
  }

  public setSoundState(enabled: boolean) {
    try {
      localStorage.setItem(this.MBASE_SOUND_STATE, JSON.stringify(enabled));
    } catch (e) {
      console.log('Fail saving sound state in browser. ' + e);
    }
  }

  public isSoundEnabled(): boolean {
    if (localStorage.getItem(this.MBASE_SOUND_STATE)) {
      try {
        return JSON.parse(localStorage.getItem(this.MBASE_SOUND_STATE));
      } catch (e) {
        console.log('Fail retrieving sound state from browser. ' + e);
        return false;
      }
    } else {
      return false;
    }
  }

  public deleteAllItems() {
    localStorage.removeItem(this.MBASE_UDID_ID);
    localStorage.removeItem(this.MBASE_LANG_ID);
    localStorage.removeItem(this.MBASE_CONTEXT_ID);
    localStorage.removeItem(this.MBASE_DEVICEDATA_ID);
    localStorage.removeItem(this.MBASE_BO_VERSION);
    localStorage.removeItem(this.MBASE_OAUTH_TOKEN);
    localStorage.removeItem(this.MBASE_SELECTED_DESK);
    localStorage.removeItem(this.MBASE_SOUND_STATE);
  }

  public deleteOldData() {
    localStorage.removeItem(this.MBASE_CONTEXT_ID);
    localStorage.removeItem(this.MBASE_SELECTED_DESK);
    localStorage.removeItem(this.MBASE_SELECTED_LOCATION_DESK);
  }

}
